module.exports = __webpack_public_path__ + "img/dbyloi-logo.e01a9f0a.svg";